// extracted by mini-css-extract-plugin
export default {"sad_santa":"InvalidRoute_sad_santa__roQzG"};